export default { grouperFunc };

function grouperFunc(param) {
    var _opt = param || {};
    var _data = [];

    //dummy
    _opt.allowDuplicate = false; //allow having more than one child item with same value
    _opt.propComparer = (item0, item1) => {
        return item0.catId === item1.catId;
    };
    //end dummy

    function _getMatchedProp(propObj, propArr, comparer) {
        var matched = null;
        propArr.forEach(function (item, index) {
            if (comparer) {
                var ret = comparer(propObj, item.parent);
                if (ret === true) {
                    matched = item;
                    return;
                }
            }
        });
        return matched;
    }

    function _getPropHolder(propObj) {
        var matched = _getMatchedProp(propObj, _data, _opt.propComparer);
        if (matched !== null) return matched;
        var datum = { parent: propObj, childs: [] };
        _data.push(datum);
        return datum;
    }

    function _getMatchedChild(target, list, comparer) {
        var matched = null;
        list.forEach(function (item, index) {
            if (comparer) {
                var ret = comparer(target, item);
                if (ret === true) {
                    matched = item;
                    return;
                }
            }
        });
        return matched;
    }

    function _checkExist(propObj, valObj) {
        if (_opt.allowDuplicate === true) return false;
        var prop = _getPropHolder(propObj);
        if (!prop) return false;
        var propVal = _getMatchedChild(valObj, prop.childs, _opt.propComparer);
        if (propVal !== null) return true;
        return false;
    }

    function _addPropVal(prop, val) {
        var propRef = _getPropHolder(prop);
        if (_checkExist(prop, val) === true) return;
        propRef.childs.push(val);
    }

    function _addList(list) {
        list.forEach(function (item, index) {
            var catPairs = item.prop.catPairs;
            catPairs.forEach(function (prop, index) {
                _addPropVal(prop.parent, prop.child);
            });
        });
    }

    return {
        addList: _addList,
        add: _addPropVal,
        getMatchedProp: function (propObj) {
            _getMatchedProp(propObj, _data, _opt.propComparer);
        },
        getData: function () {
            return _data;
        }
    };

}

